import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import Signup from "./components/Signup";
import Login from "./components/Login";
import AdminLogin from "./components/AdminLogin";
import ResetPassword from "./components/ResetPassword";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Analytics from "./pages/Analytics";
import ProfilePage from "./pages/ProfilePage";
import Disclaimer from "./pages/Disclaimer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FeedbackForm from "./pages/FeedbackForm";
import ThreadsAndBlogs from "./pages/ThreadsAndBlogs"; // Updated name
import BlogDetail from "./pages/BlogDetail";
import BlogEdit from "./pages/BlogEdit";
import CalculatorPage from "./pages/CalculatorPage";
import ApiDocs from "./pages/ApiDocs";
import Help from "./pages/Help";
import Settings from "./pages/Settings";
import BrokerIntegrations from "./pages/BrokerIntegrations";
import GoogleOAuthCallback from "./components/GoogleOAuthCallback";
import Layout from "./components/Layout";
import { Helmet, HelmetProvider } from 'react-helmet-async';

// Google Analytics page tracking component
const PageTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track pageview with Google Analytics
    if (window.gtag) {
      window.gtag('config', 'G-EDS8Z2CM4E', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);
  
  return null; // This component doesn't render anything
};

export default function App() {
  const ProtectedRoute = ({ element }) => {
    const token = localStorage.getItem('token');
    return token ? element : <Navigate to="/login" />;
  };

  const AdminRoute = ({ element }) => {
    const adminToken = localStorage.getItem('adminToken');
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    // Check for admin token first, then check regular token with admin role
    if (adminToken) {
      return element;
    } else if (token && user.role === 'admin') {
      return element;
    } else {
      return <Navigate to="/login" />;
    }
  };

  return (
    <HelmetProvider>
      <Router>
        <Helmet>
          {/* Default SEO tags */}
          <title>StockKhata | invest anywhere, maintain only here</title>
          <meta name="description" content="Stock Khata is a personal portfolio management tool that helps you analyze your stock portfolio by sector and performance. Engage with community blogs for stock market insights." />
          <meta name="keywords" content="StockKhata, stock khata, stock watchlist, portfolio tracker, investment manager, stock insights, financial analytics, stock screener, investment planner, stock monitoring, portfolio visualization, stock research tool, market watchlist, Stock Portfolio, Portfolio Analysis, Community Blogs, Stock Analysis, Financial Planning, Stock Market, Personal Finance, Sector Analysis, Investment Tracking" />
      
        </Helmet>

        <PageTracker />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/threads-blogs" element={<ThreadsAndBlogs />} /> {/* Updated path */}
          <Route path="/:id/:slug" element={<BlogDetail />} />
          <Route path="/blog/edit/:id" element={<BlogEdit />} />
          <Route path="/calculators" element={<CalculatorPage />} />
          <Route path="/api-docs" element={<ApiDocs />} /> {/* Added ApiDocs route */}
          <Route path="/auth/google/callback" element={<GoogleOAuthCallback />} />

          {/* Protected routes with Layout */}
          <Route path="/dashboard" element={<ProtectedRoute element={<Layout />} />}>
            <Route index element={<Dashboard />} />
          </Route>
          <Route path="/analytics" element={<ProtectedRoute element={<Layout />} />}>
            <Route index element={<Analytics />} />
          </Route>
          <Route path="/feedback" element={<ProtectedRoute element={<Layout />} />}>
            <Route index element={<FeedbackForm />} />
          </Route>
          <Route path="/help" element={<ProtectedRoute element={<Layout />} />}>
            <Route index element={<Help />} />
          </Route>
          <Route path="/settings" element={<ProtectedRoute element={<Layout />} />}>
            <Route index element={<Settings />} />
          </Route>
          <Route path="/broker-integrations" element={<ProtectedRoute element={<Layout />} />}>
            <Route index element={<BrokerIntegrations />} />
          </Route>
          
          {/* Other protected routes without layout */}
          <Route path="/admin-dashboard" element={<AdminRoute element={<AdminDashboard />} />} />
          <Route path="/profile" element={<ProtectedRoute element={<ProfilePage />} />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}
